// Simple arrow icon used in the mobile artwork header to navigate back.
export default function GoBackArtworkViewIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={`go-back-artwork-view-icon ${className}`.trim()}
      onClick={onClick}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.707 4.293a1 1 0 0 1 0 1.414L10.414 11H20a1 1 0 1 1 0 2h-9.586l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z" />
    </svg>
  );
}